import { default as TentacleDownloadButton } from "./TentacleDownloadButton";
export * from "./TentacleDownloadButton";
export default TentacleDownloadButton;
